export const FilterPopUpStyles = {
  menuItem: {
    fontSize: "var(--font-size-14)",
    fontFamily: "var(--font-noto-sans)",
    color: "var(--primary-black) !important",
    fontWeight: "var(font-weight-400)",
    lineHeight: "22px",
  },
};
